import { getSalesforceToggles, patchSalesforceToggles } from 'app/modules/integrations/api'
import React, { Component } from 'react'
import IntegrationToggles from 'components/IntegrationToggles'
import { OWNER_TOGGLES, hydrateOwnerToggles } from './model'
import withNotifications from 'components/shared/notifications'

class SalesforceOwnerRouting extends Component {

  initialToggles = {}
  toggles = {}
  state = {
    canSave: false,
    togglesLoaded: false
  }

  componentDidMount() {
    getSalesforceToggles()
      .then(this.receiveToggles)
  }

  togglesChanged = (checked, { type }) => {
    this.toggles = Object.assign({}, this.toggles, { [type]: checked })
    this.setState({ canSave: this.togglesAreDifferent() })
  }

  togglesAreDifferent = () => !!OWNER_TOGGLES.find(({ type }) => this.initialToggles[type] !== this.toggles[type])

  pickOnlyOwnerRoutingToggles = toggles => _.pick(toggles, OWNER_TOGGLES.map(ot => ot.type))

  receiveToggles = toggles => {
    const selectedToggles = this.pickOnlyOwnerRoutingToggles(toggles)
    this.initialToggles = selectedToggles
    this.toggles = selectedToggles
    this.setState({ togglesLoaded: true })
  }

  handleSaveSuccess = () => {
    this.props.notifications.success('Successfully updated Salesforce Owner Routings!')
    this.initialToggles = Object.assign({}, this.toggles)
    this.setState({ canSave: false })
  }

  handleSaveFailure = () => this.props.notifications.error('Failed to update Salesforce Owner Routings')

  onSave = () => {
    patchSalesforceToggles(this.toggles)
      .then(this.handleSaveSuccess)
      .catch(this.handleSaveFailure)
  }

  render() {
    if (!this.state.togglesLoaded)
      return null

    return (
      <div className={this.props.className}>
        <IntegrationToggles
          toggles={!this.state.canSave ? hydrateOwnerToggles(this.initialToggles) : hydrateOwnerToggles(this.toggles)}
          onChange={this.togglesChanged}
        />
        {this.state.canSave && (
          <div className="drift-button drift-button-primary" onClick={this.onSave}>Save Changes</div>
        )}
      </div>
    )
  }
}

export default withNotifications(SalesforceOwnerRouting)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceConfig/OwnerRouting.js